import { shape, number, string, arrayOf, oneOfType, bool, object, objectOf } from 'prop-types';

export const elementContentType = shape({
    align: string,
    allowComments: bool,
    alt: string,
    aspectRatio: number,
    backgroundColor: string,
    borderRadius: number,
    color: string,
    containerBackgroundColor: string,
    href: string,
    paddingTop: number,
    paddingBottom: number,
    paddingRight: number,
    paddingLeft: number,
    fontFamily: string,
    fontSize: string,
    fontStyle: string,
    fontWeight: string,
    lineHeight: string,
    textDecoration: string,
    innerHorizontalPadding: number,
    innerVerticalPadding: number,
    iconSize: number,
    icons: arrayOf(shape({
        title: string,
        href: string,
        active: bool,
        src: shape({
            color: string,
            bw: string,
        }),
    })),
    iconVersionColor: bool,
    surveyTitle: string,
    type: string,
    iconImages: object,
    playButtonColor: string,
    src: string,
    rawSource: string,
});

export const elementType = shape({
    elmIdx: string.isRequired,
    type: string.isRequired,
    content: elementContentType.isRequired,
});

export const columnType = shape({
    columnIdx: string.isRequired,
    size: oneOfType([string, number]),
    columnItems: arrayOf(elementType),
});

export const contentType = shape({
    columnNum: number.isRequired,
    backgroundColor: string.isRequired,
    wrapperBackgroundColor: string.isRequired,
    paddingTop: number.isRequired,
    paddingBottom: number.isRequired,
    structureLocked: bool.isRequired,
    columns: arrayOf(columnType),
});

export const blockType = shape({
    index: string.isRequired,
    type: string.isRequired,
    title: string.isRequired,
    thumbnailUrl: string,
    content: contentType.isRequired,
});

export const sessionType = shape({
    authorization: string.isRequired,
    integration: string.isRequired,
    collaboration: object.isRequired,
    controls: arrayOf(string).isRequired,
    loading: bool.isRequired,
    user: shape({
        firstName: string.isRequired,
        lastName: string.isRequired,
        email: string.isRequired,
        userID: string.isRequired,
        accountID: string.isRequired,
        parentID: string.isRequired,
        groupID: string.isRequired,
        plan: string.isRequired,
        features: objectOf(bool).isRequired,
    }).isRequired,
});

export const remoteUserType = shape({
    accountId: string.isRequired,
    draftId: string.isRequired,
    email: string.isRequired,
    firstName: string.isRequired,
    hasAutoSaveEnabled: bool.isRequired,
    lastName: string.isRequired,
    socketId: string.isRequired,
});
